import { render, staticRenderFns } from "./ContentSearch.vue?vue&type=template&id=7a043970&scoped=true"
import script from "./ContentSearch.vue?vue&type=script&lang=ts"
export * from "./ContentSearch.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./ContentSearch.vue?vue&type=style&index=0&id=7a043970&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "7a043970",
  "5cb3c4bb"
  
)

export default component.exports